export default function ModeMoonIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M253.24,374c-70.16,0-127.24-57.08-127.24-127.24,0-54.1,34.3-102.4,85.36-120.18h0c7.84-2.73,15.37,4.8,12.64,12.64h0c-3.95,11.33-5.95,23.22-5.95,35.34,0,59.13,48.26,107.4,107.39,107.4,12.12,0,24.01-2,35.35-5.95h0c7.84-2.73,15.37,4.8,12.64,12.64h0c-17.79,51.06-66.09,85.36-120.18,85.36ZM199.93,153.5c-32.98,18.87-54.08,54.28-54.08,93.26,0,59.22,48.18,107.39,107.39,107.39,38.98,0,74.39-21.1,93.26-54.08-6.93,1.15-13.96,1.74-21.06,1.74-70.16,0-127.24-57.08-127.24-127.24,0-7.1.58-14.14,1.74-21.06Z" />
    </svg>
  );
}
